module.exports = __webpack_public_path__ + "static/media/1.ee5c979a.webp";